import render from './render'

export default {
  name: 'FilterSendings',

  props: {
    query: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
